import { c as _c } from "react/compiler-runtime";
import { Krub } from 'next/font/google';
import { ReactNode } from 'react';
import classnames from 'classnames';
const krub = Krub({
  weight: ['400', '600'],
  style: ['normal'],
  subsets: ['latin']
});
interface Props {
  children: ReactNode;
}
const className = classnames(krub.className, 'h-full', 'bg-background-color');
const Body = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <body className={className}>{children}</body>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Body;